import classNames from 'classnames'

interface DotsProps {
  dotsQuantity: number
  currentSlide: number
  onMoveToSlide: (index: number) => void
}

export const Dots = ({
  dotsQuantity,
  currentSlide,
  onMoveToSlide
}: DotsProps) => {
  return (
    <div className="flex justify-center">
      <div className="dots py-1 px-5 flex justify-center items-center gap-1 bg-v3-orange-550 rounded-3xl">
        {[...Array(dotsQuantity).keys()].map(idx => (
          <button
            key={idx}
            onClick={() => onMoveToSlide(idx)}
            className={classNames(
              'dot w-[6px] h-[6px] rounded-full border border-white',
              {
                'bg-white': currentSlide === idx
              }
            )}
          />
        ))}
      </div>
    </div>
  )
}
